import { Component, OnInit } from '@angular/core';

import { CamRoutes } from '@camelot/menu';

import { ECallbackRoute } from '../../callback/callback.routes';
import { BasePage } from '../../core/abstract/basePage';
import { ETasksRoute } from '../../tasks/tasks.routes';

type Scope = '' | 'tasks' | 'ponto';
@Component({
  host: { 'data-cid': 'redirect-page' },
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
  standalone: false,
})
export class RedirectPage extends BasePage implements OnInit {
  private _scope: Scope = '';
  private _taskId: string = '';
  private _state: string = '';
  private _code: string = '';

  ngOnInit() {
    this._registerSubscription(
      this._getQueryParams({ scope: '', taskId: '', myState: '', myCode: '' }).subscribe(
        ({ scope, taskId, myState, myCode }) => {
          this._scope = scope as Scope;
          this._taskId = taskId;
          this._state = myState;
          this._code = myCode;
        }
      )
    );

    const urlParams = this._generateUrlParams();
    this._router.navigateByUrl(CamRoutes.getAbsoluteUrl(urlParams.enum, urlParams.data));
  }

  private _generateUrlParams() {
    switch (this._scope) {
      case 'tasks':
        return {
          enum: [ETasksRoute.tasks, ETasksRoute.view],
          data: {
            id: this._taskId ?? '',
          },
        };
      case 'ponto':
        return {
          enum: [ECallbackRoute.callback, ECallbackRoute.ponto],
          data: {
            state: this._state ?? '',
            code: this._code ?? '',
          },
        };
      default:
        return { enum: [], data: {} };
    }
  }
}
